import { config } from '@/lib/config'

/** The callback URL the merchant sets on its Unlimit account: one per processor (#TAG-2852). */
export const unlimitWebhookUrl = (processorId: string): string =>
  `${config.apiBaseUrl}/api/public/webhooks/unlimit/${processorId}`
